import { __read } from '../node_modules/tslib/tslib.es6.esm.js';
import { isDateRangeMask, DATE_RANGE_SEPARATOR, NUMBERS_IN_DATE_MASK } from './maskTypes.esm.js';

/**
 * Format the date.
 *
 * @param {string} value The input value.
 * @returns {string} Formatted date.
 */
function formatMonths(value) {
    if (+value > 12) {
        return '12';
    }
    return value.length < 2 ? value.concat(Array(3 - value.length).join('_')) : value;
}
function formatDays(value) {
    if (+value > 31)
        return '31';
    return value.length < 2 ? value.concat(Array(3 - value.length).join('_')) : value;
}
function formatYear(value) {
    return value.length < 4 ? value.concat(Array(5 - value.length).join('_')) : value;
}
/**
 *
 * The function does not allow to enter invalid date (month and day)
 * and adds mask to the input
 * @param {string} value The input value
 * @param {string} maskType Mask that is being used to format the string
 * @return {string} Formatted date
 */
function normalizeDate(value, maskType) {
    if (!value) {
        return '';
    }
    var onlyNums = value.replace(/[^\d]/g, '');
    if (!onlyNums)
        return value;
    var isDateRange = isDateRangeMask(maskType);
    var _a = __read(maskType.split(DATE_RANGE_SEPARATOR), 1), dateFormat = _a[0];
    var _b = __read([
        onlyNums.slice(0, NUMBERS_IN_DATE_MASK),
        onlyNums.slice(NUMBERS_IN_DATE_MASK),
    ], 2), firstDateNumbers = _b[0], secondDateNumbers = _b[1];
    var formattedDays = [firstDateNumbers, secondDateNumbers]
        .filter(function (dateNums) { return dateNums || isDateRange; })
        .map(function (dateNumbers) {
        if (dateFormat !== 'YYYY/MM/DD' && dateNumbers.length <= 2) {
            return dateFormat === 'DD/MM/YYYY'
                ? "".concat(formatDays(dateNumbers), "/__/____")
                : "".concat(formatMonths(dateNumbers), "/__/____");
        }
        if (dateNumbers.length <= 4) {
            if (dateFormat === 'YYYY/MM/DD') {
                return "".concat(formatYear(dateNumbers), "/__/__");
            }
            return "".concat(dateNumbers.slice(0, 2), "/").concat(dateFormat === 'DD/MM/YYYY'
                ? "".concat(formatMonths(dateNumbers.slice(2)), "/____")
                : "".concat(formatDays(dateNumbers.slice(2)), "/____"));
        }
        switch (dateFormat) {
            case 'DD/MM/YYYY':
                return "".concat(formatDays(dateNumbers.slice(0, 2)), "/").concat(formatMonths(dateNumbers.slice(2, 4)), "/").concat(formatYear(dateNumbers.slice(4, 8)));
            case 'MM/DD/YYYY':
                return "".concat(formatMonths(dateNumbers.slice(0, 2)), "/").concat(formatDays(dateNumbers.slice(2, 4)), "/").concat(formatYear(dateNumbers.slice(4, 8)));
            default:
                // 'YYYY/MM/DD'
                return "".concat(formatYear(dateNumbers.slice(0, 4)), "/").concat(formatMonths(dateNumbers.slice(4, 6)), "/").concat(formatDays(dateNumbers.slice(6, 8)));
        }
    });
    return formattedDays.join(DATE_RANGE_SEPARATOR);
}

export { normalizeDate };
//# sourceMappingURL=normalizers.esm.js.map
